import { ApplicationTypes, CornerBoltHoles, attachComponent, featureLabels } from 'metalworks-domain'

import {
  detailComponent,
  distanceDimensionComponent,
  entityHeaderComponent,
  propertyPageComponent,
} from '@salsita-ai/platform-project-sdk/domain'
import { DeleteEntityButton, ReplaceEntityDropdown } from '@salsita-ai/platform-project-sdk/react'

import { HolePropertyPage } from '../ui/property-pages/HolePropertyPage'

export const cornerBoltHoleComponents = [
  // TODO: yaml
  attachComponent
    .withComponent(detailComponent, 'main')
    .withEntity('CornerBoltHoles')
    .attach(() => {
      return {
        title: featureLabels[CornerBoltHoles.type],
        subtitle: 'Bolt hole for all corners of the plate.',
        description: 'All four holes are the same, their diameter and positions relative to the edge can be adjusted.',
        thumbnailUrl: '/thumbnails/circular-hole.png',
      }
    }),
  attachComponent
    .withComponent(propertyPageComponent, 'box')
    .withEntity('CornerBoltHoles')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      page: <HolePropertyPage id={s.id} disableAnchorSwitching />,
    })),
  attachComponent
    .withComponent(entityHeaderComponent, 'main')
    .withEntity('CornerBoltHoles')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      // TODO: this now needs separate replace entity component
      primaryButton: <ReplaceEntityDropdown entityId={s.id} />,
      secondaryButton: <DeleteEntityButton entityId={s.id} />,
    })),
  // TODO: yaml
  attachComponent
    .withComponent(distanceDimensionComponent, 'diameter')
    .withEntity('CornerBoltHoles')
    .attach(
      s => ({
        value: s.radius * 2,
        min: 0.5,
        max: Math.min(20, s.$plate.$maxFeatureSize.x, s.$plate.$maxFeatureSize.y),
        unit: 'mm',
      }),
      v => {
        return {
          // TODO: can this be diameter - it will not be possible to migrate to yaml
          radius: v.value / 2,
        }
      }
    ),
]
